import { PropsWithChildren, MouseEventHandler, ReactNode } from 'react';
import styles from './TextLink.module.scss';

interface TextLinkProps {
  label: string | ReactNode;
  onClick: MouseEventHandler;
  className?: string;
  ariaLabel?: string;
  children?: React.ReactNode;
}

export function TextLink({
  label,
  onClick,
  className,
  ariaLabel,
  children
}: PropsWithChildren<TextLinkProps>) {
  return (
    <button
      onClick={onClick}
      className={`${styles['text-link']} ${className}`}
      aria-label={ariaLabel ?? (label as string)}
    >
      {label ?? children}
    </button>
  );
}
